import { F_Fammily } from "../../../../util/config-fonts";
import React from "react";

export default class Category extends React.PureComponent {
  render() {
    return (
      <div className="col-lg-12 my-4 py-4" id={this.props.ID}>
        <div className="aligncenter text-center flex items-center gap-8">
          <div
            className="bg-gray-50 h-px w-[40%]"
            style={{ border: "2px solid #ecf0f1", marginBottom: 10 }}
          />
          <h1
            style={{
              fontSize: 21,
              fontFamily: F_Fammily.Medium,
              margin: 0,
              marginTop: 30,
              marginBottom: 15,
              fontWeight: "bold",
            }}
          >
            {this.props.Category}
          </h1>
        </div>
      </div>
    );
  }
}
